
const danhSachCongViec = (state) => state.danhSachCongViec;
const danhSachTrangThaiCv = (state) => state.danhSachTrangThaiCv;
const danhSachDonViTaoCongViec = (state) => state.danhSachDonViTaoCongViec;
const danhSachDonViGanCongViec = (state) => state.danhSachDonViGanCongViec;
const chiTietCongViec = (state) => state.chiTietCongViec;
const danhSachCongViecLQ = (state) => state.danhSachCongViecLQ;
const danhSachLichSuGiaoViec = (state) => state.danhSachLichSuGiaoViec;
const danhSachMucDoCongViec = (state) => state.danhSachMucDoCongViec;
const danhSachLichSuThayDoiTrangThaiCongViec = (state) =>
  state.danhSachLichSuThayDoiTrangThaiCongViec;
const danhSachHienThiCotCongViec = (state) => state.danhSachHienThiCotCongViec;
const danhSachHienThiCotCongViecCapNhat = (state) =>
  state.danhSachHienThiCotCongViecCapNhat;
const danhSachLichSuDonDocCongViec = (state) =>
    state.danhSachLichSuDonDocCongViec;

export default {
  danhSachCongViec,
  danhSachTrangThaiCv,
  danhSachDonViTaoCongViec,
  danhSachDonViGanCongViec,
  chiTietCongViec,
  danhSachCongViecLQ,
  danhSachLichSuGiaoViec,
  danhSachMucDoCongViec,
  danhSachLichSuThayDoiTrangThaiCongViec,
  danhSachHienThiCotCongViec,
  danhSachHienThiCotCongViecCapNhat,
  danhSachLichSuDonDocCongViec,
};
